var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronsLeft = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7803 6.53033C12.0732 6.23744 12.0732 5.76256 11.7803 5.46967C11.4874 5.17678 11.0126 5.17678 10.7197 5.46967L4.71967 11.4697C4.42678 11.7626 4.42678 12.2374 4.71967 12.5303L10.7197 18.5303C11.0126 18.8232 11.4874 18.8232 11.7803 18.5303C12.0732 18.2374 12.0732 17.7626 11.7803 17.4697L6.31066 12L11.7803 6.53033ZM19.2803 6.53033C19.5732 6.23744 19.5732 5.76256 19.2803 5.46967C18.9874 5.17678 18.5126 5.17678 18.2197 5.46967L12.2197 11.4697C11.9268 11.7626 11.9268 12.2374 12.2197 12.5303L18.2197 18.5303C18.5126 18.8232 18.9874 18.8232 19.2803 18.5303C19.5732 18.2374 19.5732 17.7626 19.2803 17.4697L13.8107 12L19.2803 6.53033Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronsLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevrons-left.96c5f9a0516008899d6170ef7663b735.svg";